export const mutations = {
  addFlux (state, flux) {
    state.flux = flux
  },
  setFlux (state, flux) {
    state.flux = flux
  },
  addFluxs(state, flux){
    state.fluxs = [ ...flux ]
  },
  addFluxPage(state, flux){
    state.fluxs = flux
  },
}
